<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';

import WootSubmitButton from '../../../../components/buttons/FormSubmitButton.vue';
// import Modal from '../../../../components/Modal.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';

export default {
  name: 'AddCanned',
  components: {
    WootSubmitButton,
    // Modal,
    WootMessageEditor,
  },
  props: {
    responseContent: {
      type: String,
      default: '',
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      shortCode: '',
      content: this.responseContent || '',
      addCanned: {
        showLoading: false,
        message: '',
      },
      show: true,
    };
  },
  validations: {
    shortCode: {
      required,
      minLength: minLength(2),
    },
    content: {
      required,
    },
  },
  methods: {
    resetForm() {
      this.shortCode = '';
      this.content = '';
      this.v$.shortCode.$reset();
      this.v$.content.$reset();
    },
    addCannedResponse() {
      // Show loading on button
      this.addCanned.showLoading = true;
      // Make API Calls
      this.$store
        .dispatch('createCannedResponse', {
          short_code: this.shortCode,
          content: this.content,
        })
        .then(() => {
          // Reset Form, Show success message
          this.addCanned.showLoading = false;
          useAlert(this.$t('CANNED_MGMT.ADD.API.SUCCESS_MESSAGE'));
          this.resetForm();
          this.onClose();
        })
        .catch(error => {
          this.addCanned.showLoading = false;
          const errorMessage =
            error?.message || this.$t('CANNED_MGMT.ADD.API.ERROR_MESSAGE');
          useAlert(errorMessage);
        });
    },
  },
};
</script>

<template>
  <!-- <Modal v-model:show="show" :on-close="onClose"> -->
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header
      :header-title="$t('CANNED_MGMT.ADD.TITLE')"
      :header-content="$t('CANNED_MGMT.ADD.DESC')"
    />
    <form class="flex flex-col w-full" @submit.prevent="addCannedResponse()">
      <div class="w-full">
        <label :class="{ error: v$.shortCode.$error }">
          {{ $t('CANNED_MGMT.ADD.FORM.SHORT_CODE.LABEL') }}
          <input
            v-model="shortCode"
            type="text"
            :placeholder="$t('CANNED_MGMT.ADD.FORM.SHORT_CODE.PLACEHOLDER')"
            @blur="v$.shortCode.$touch"
          />
        </label>
      </div>

      <div class="w-full">
        <label :class="{ error: v$.content.$error }">
          {{ $t('CANNED_MGMT.ADD.FORM.CONTENT.LABEL') }}
        </label>
        <div class="editor-wrap">
          <WootMessageEditor
            v-model="content"
            class="message-editor [&>div]:px-1"
            :class="{ editor_warning: v$.content.$error }"
            enable-variables
            :enable-canned-responses="false"
            :placeholder="$t('CANNED_MGMT.ADD.FORM.CONTENT.PLACEHOLDER')"
            @blur="v$.content.$touch"
          />
        </div>
      </div>
      <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
        <WootSubmitButton
          :disabled="
            v$.content.$invalid ||
            v$.shortCode.$invalid ||
            addCanned.showLoading
          "
          :button-text="$t('CANNED_MGMT.ADD.FORM.SUBMIT')"
          :loading="addCanned.showLoading"
        />
        <button class="button clear" @click.prevent="onClose">
          {{ $t('CANNED_MGMT.ADD.CANCEL_BUTTON_TEXT') }}
        </button>
      </div>
    </form>
  </div>
  <!-- </Modal> -->
</template>

<style scoped lang="scss">
::v-deep {
  .ProseMirror-menubar {
    @apply hidden;
  }

  .ProseMirror-woot-style {
    @apply min-h-[12.5rem];

    p {
      @apply text-base;
    }
  }
}
</style>
